export default "__VITE_ASSET__Bkk5aQsj__"